module.exports = __webpack_public_path__ + "teqbahn-assets/media/29.5821abcf.png";